import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'border-corner-rounded',
  'IconBorderCornerRounded',
  [['path', { d: 'M4 20v-10a6 6 0 0 1 6 -6h10', key: 'svg-0' }]],
);
